import React, {Component} from 'react';
import {connect} from 'react-redux';
 import {bindActionCreators} from 'redux';
import queryString from 'query-string'
import classNames from 'classnames';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
var async = require('async');
import {makeRequest,displayMessage,dispatchAction}  from 'actions';
import FaDownload from 'react-icons/lib/fa/download';
import {Link} from 'react-router';
import {FETCH_CONTRACTORS} from "actions/actionTypes";
import {Row, Col, Form, FormGroup, Checkbox, Modal, ControlLabel, FormControl, Button} from 'react-bootstrap';
import config from  '../../../../config';
import AMTSalesProductsSearchBox from 'dashboard/reports/AMT/AMTSalesProductsSearchBox'
 import AMTSalesProductsListTable from'dashboard/reports/AMT/AMTSalesProductsListTable';
import AMTSalesNotificationsSearchBox from 'dashboard/reports/AMT/AMTSalesNotificationsSearchBox'
import AMTSalesNotificationsListTable from'dashboard/reports/AMT/AMTSalesNotificationsListTable';
import PaginationBox from'shared/PaginationBox';

import {onRowSelect,linkFormatter, onAllRowSelect,customMultiSelect} from 'util/Utils';



class AMTSalesPage extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }
    constructor(props, context) {
        super(props, context);
         var queryParams = queryString.parse(this.props.location.search);
        var showModal = false
        if (this.props.location.pathname.includes('/add')){
            showModal =true;
        }
        this.state = {
           sortBy:  _.get(queryParams, 'sortBy') ?_.get(queryParams, 'sortBy') : (_.get(queryParams, 'type','products') == 'products'?  'PublishedInShopifyAt:-1': 'Type:-1'),
            currentPage: queryParams.page ?  parseInt(queryParams.page) : 1,
          selectAllRecords:false,
            currentRecord:{},
                productsList: {
                    data: [],
                    total: 'initial',
                    fetched: false,
                },
            notificationsList: {
                data: [],
                total: 'initial',
                fetched: false,
            },
              showModal:showModal,
            recordIDs:[],
            productDescriptionInputVisible:false,
            currentScreen:_.get(queryParams, 'type','products'),
        };
        this.searchBox = false;
    };

    resetSearch() {
        this.props.dispatchAction({}, RESET_TRANSACTIONS)
        this.setState({

            sortBy: '',
            displayGeneratePayoutBox: false,

        });
    }
    onSortChange(field, sortOrder){
         this.setState({sortBy: field + ':' + (sortOrder ==  'asc' ? 1 : -1)}, function () {
            this.refs.pagination.resetPagination();
            this.search()
        })
    }
    search(params = {}) {
        console.log('search param', params  );
        var methodData = {
             'not_display_success_message': true
        };
        var {queryParams} = this[this.state.currentScreen+'SearchBox'].getSearchParams(),self = this;
        if (!queryParams){
            return
        }
    //    console.log('queryParams', queryParams  );
        if (this.state.sortBy) {
            queryParams.sortBy = this.state.sortBy;
            queryParams.sortBySecondary  = '_id:-1'; /* without secondary sort query, the order of documents with the same fields is not guaranteed across pages */
        }
        if ( this.state.currentScreen =='products') {
            if (!queryParams.sortBy){
                queryParams.sortBy ='fromPublishedAt:-1'
            }
            methodData.endpoint = '/products'
            queryParams.lookup=['SellerID']
            queryParams.listingStatuses =  ['Listings']
        }else{
            if (!queryParams.sortBy){
                queryParams.sortBy ='Type:-1'
            }
            queryParams.UserID = this.props.userReducer.user._id
            queryParams.Types=['PriceDrop', 'SoldOut']
            queryParams.ProductRecordExists =true
             methodData.endpoint = '/subscriptions'
        }

        _.extend(queryParams, params);


        if (queryParams.page === 1) {
            delete queryParams.page
        }

        //console.log('queryParams.page', queryParams.page  );
        if (_.isUndefined(queryParams.page)) { /* do not clear selected records when only pagination is changed */
            this.setState({recordIDs:[]})
        }
          const stringified = queryString.stringify(_.omit(queryParams, ['include','Statuses','listingStatuses','addFields', 'InventoryOwnership', 'lookup', 'all', 'sortBySecondary']));
        this.context.router.push('/admin/reports?tab=atm&type='+this.state.currentScreen +'&'+ stringified);
        return this.props.makeRequest(queryParams, methodData).then(res=>{
            self.setState({
                currentPage:_.isUndefined(queryParams.page) ?1:queryParams.page,
                [this.state.currentScreen+'List']: {
                    data: res.data.data,
                    total: res.data.total,
                    fetched: true,
                }
            })
            if (self.refs.pagination && _.isUndefined(queryParams.page)) {
                self.refs.pagination.resetPagination();
            }
        }).catch(err => {
        });
    }

    toggleAllRecordsSelection(value) {
        if (value) {
            this.setState({ selectAllRecords:true});
        }else{
            this.setState({ selectAllRecords:false});
        }
    }
    openModalDialog(row, currentAction) {
      this.setState({
           currentRecord: {
              ...row,
               notificationTypes:_.map(_.get(row,'ProductSubscriptions',[]),item=> {
                   return item.Type
               }),
               currentAction:currentAction
          }
      });
    }


    deleteSubscription(row) {

        var methodData = {
            type: 'delete',
            "endpoint": "/subscriptions" + '/' + encodeURIComponent(row._id),
            messageData: {'#1#': 'Subscription'},
            messageCode: 'recordDeleted',
        };

        this.props.makeRequest({ }, methodData).then(res => {
            this.search({page: this.state.currentPage })
        }).catch(err => {
            console.log('e', err );
        });

    }

displayModalContent(){

        if (_.get(this.state, 'currentRecord.currentAction') == 'CopyDescription') {
             return <div  >
                <FormGroup>
                    <div>{_.get(this.state.currentRecord, 'Description', '')}
                    </div>
                </FormGroup>
            </div>
        }else if (_.get(this.state, 'currentRecord.currentAction') == 'DisplayUserNotes') {
            return <div  >
                <FormGroup>
                    <div>{_.get(this.state.currentRecord, 'CustomData.UserNotes', '')}
                    </div>
                </FormGroup>
            </div>
        }else if (_.get(this.state, 'currentRecord.currentAction') == 'DisplayProductImages') {
            return <div  >
                <Carousel
                    ref={ div => {
                    this.imageSlider = div;
                } }  >
                    {_.map(_.get(this.state.currentRecord, 'OriginalImages'),  (image,index)=> {

                    return <div  className="cursor-pointer" onClick={() => {
                        window.open(formatImageForBucket(_.get(this.state.currentRecord, ['OriginalImages',_.get(this.imageSlider, 'state.selectedItem'), 'URL'])), "_blank")

                    }}
                        key={image._id+' ' +index}
                  >
                    <img download style={{ maxWidth:'400px',  maxHeight:'400px'}} title={''}  src={image.URL} />

                    </div>;
                    })}
                </Carousel>

            </div>
        }  else  if (_.get(this.state, 'currentRecord.currentAction') == 'SignUpForNotification') {
            var productLink = linkFormatter({}, this.state.currentRecord, {
                labelPath: ['ProductName'],
                path: ['ShopifyProductHandle'],
                placeholder: '[product_handle]',
                template: config.getEnvironment().shopify.productCustomerUrlTemplate
            })
            return <div  >
                <FormGroup>
                    <ControlLabel>Product:</ControlLabel>
                    <div> {productLink}</div>
                </FormGroup>
                <FormGroup>
                    <ControlLabel>Select Notification Types:</ControlLabel>
                    <Checkbox
                        onClick={() => {
                            if(_.includes(_.get(this.state.currentRecord,'notificationTypes',[]),'PriceDrop')){
                                var notificationTypes = _.pull([..._.get(this.state.currentRecord,'notificationTypes',[])], 'PriceDrop')
                            }else{
                                var notificationTypes =_.uniq(_.concat(_.get(this.state.currentRecord,'notificationTypes',[]),['PriceDrop']))
                            }

                            this.setState({
                                'currentRecord': {
                                    ...this.state.currentRecord,
                                    notificationTypes:notificationTypes,
                                }
                            })
                        }}
                        checked={_.includes(_.get(this.state.currentRecord,'notificationTypes',[]),'PriceDrop')}>Price Drop</Checkbox>
                    <Checkbox
                        onClick={() => {
                            if(_.includes(_.get(this.state.currentRecord,'notificationTypes',[]),'SoldOut')){
                                var notificationTypes = _.pull([..._.get(this.state.currentRecord,'notificationTypes',[])], 'SoldOut')
                            }else{
                                var notificationTypes =_.uniq(_.concat(_.get(this.state.currentRecord,'notificationTypes',[]),['SoldOut']))
                            }

                            this.setState({
                                'currentRecord': {
                                    ...this.state.currentRecord,
                                    notificationTypes:notificationTypes,
                                }
                            })
                        }}
                        checked={_.includes(_.get(this.state.currentRecord,'notificationTypes',[]),'SoldOut') }>Sold Out</Checkbox>

                </FormGroup>
            </div>
        }else  if (_.get(this.state, 'currentRecord.currentAction') == 'AddUserNotes') {
            var productLink = linkFormatter({}, this.state.currentRecord, {
                labelPath: ['ProductName'],
                path: ['ShopifyProductHandle'],
                placeholder: '[product_handle]',
                template: config.getEnvironment().shopify.productCustomerUrlTemplate
            })
            return <div  >
                <FormGroup>
                    <ControlLabel>Product:</ControlLabel>
                    <div> {productLink}</div>
                </FormGroup>
                <FormGroup>
                    <ControlLabel>Add Note:</ControlLabel>
                    <FormControl type="text"
                                 componentClass="textarea" rows="5"
                                 onChange={(e) => this.setState({
                                     'currentRecord': {
                                         ...this.state.currentRecord,
                                         UserNotes: e.target.value
                                     }
                                 })}
                                 value={_.get(this.state.currentRecord, 'UserNotes','')}
                                 placeholder=""/>
                </FormGroup>

            </div>
        }
    }
    updateProductRecord(row, dataToUpdate){
    console.log('this.state.pending', this.state.pending  );
    if (this.state.pending){
        return
    }
    this.setState({pending:true})
var foundIndex = _.findIndex(this.state.productsList.data, {_id:row._id})

      var  updatedProducts = [...this.state.productsList.data.slice(0, foundIndex),
            {...row, CustomData:_.extend( _.get(row, 'CustomData',{}),_.get(dataToUpdate, 'CustomData',{}))},
            ...this.state.productsList.data.slice(foundIndex + 1)];
this.setState({productList:{...this.state.productList, data:updatedProducts}})
        console.log('foundIndex', foundIndex  );
        console.log('updatedProducts', updatedProducts  );
        this.props.makeRequest(dataToUpdate, {
            "endpoint": "/products/" + encodeURIComponent(_.get(row, '_id')),
            type: "patch",

        }).then(res => {

            this.search({page: this.state.currentPage }).then(()=>{
                this.setState({pending:false})
            })
        }).catch(e=>{
            this.setState({pending:false})
        })



    }
      forceDownload2(blob, filename) {
    var a = document.createElement('a');
    a.download = filename;
    a.href = blob;
    // For Firefox https://stackoverflow.com/a/32226068
    document.body.appendChild(a);
    a.click();
    a.remove();
}

// Current blob size limit is around 500MB for browsers
      downloadResource(filename,url) {
    if (!filename) filename = url.split('\\').pop().split('/').pop();
    fetch(url, {
        headers: new Headers({
            'Origin': location.origin
        }),
        mode: 'no-cors'
    })
        .then(response => response.blob())
        .then(blob => {
            console.log('blob', blob  );
            let blobUrl = window.URL.createObjectURL(blob);
            this.forceDownload(blobUrl, filename);
        })
        .catch(e => console.error(e));
}


      forceDownload(fileName,url){
    console.log('forceDownload', fileName,url );
  //  var url = link.getAttribute("data-href");
  // var fileName = link.getAttribute("download");
   // link.innerText = "Working...";
    var xhr = new XMLHttpRequest();
    xhr.open("GET", url+'?', true);/* +'?' is needed to workaround issue with  images (cached in browser) without CORS headers https://stackoverflow.com/questions/12648809/cors-policy-on-cached-image*/
    xhr.responseType = "blob";
    xhr.onload = function(){
        var urlCreator = window.URL || window.webkitURL;
        var imageUrl = urlCreator.createObjectURL(this.response);
        var tag = document.createElement('a');
        tag.href = imageUrl;
        tag.download = fileName;
        document.body.appendChild(tag);
        tag.click();
        document.body.removeChild(tag);
      //  link.innerText="Download Image";
    }
    xhr.send();
}
    render() {
 console.log('this.state', this.state  );
 var self = this;
        return (
            <div >
                <Row className="">

                    <div   style={{}}
                           className={classNames('font-size-20 text-bold  text-center ',{'welcome-user-box': _.size(_.intersection(this.props.userReducer.user.Roles, ['Administrator'])) > 0}, {'top25': _.size(_.intersection(this.props.userReducer.user.Roles, ['Administrator'])) == 0})}
                    >
                        Welcome {this.props.userReducer.user.firstName}
                    </div>
                 </Row>
                <Row className="">
                <Col xs={12}   >
                    <Button   className={classNames('pull-left btn btn-default',{  'btn-primary':  this.state.currentScreen =='products'})}
                      type="button"
                            onClick={(e) => this.setState({currentScreen: 'products',sortBy:'',currentPage:0}, ()=>{
                                this.search()
                            }) }>
                        Recent Listings
                    </Button>
                   <Button   className={classNames('left30 pull-left btn btn-default',{  'btn-primary':  this.state.currentScreen =='notifications'})}
                                                           type="button"
                            onClick={(e) => this.setState({currentScreen: 'notifications',sortBy:'',currentPage:0}, ()=>{
                                this.search()
                            }) }>
                        Notifications
                    </Button>
                </Col>
                </Row>
                {this.state.currentScreen == 'products' ?
                    <div>
                        {/*<AMTSalesActionsBox     recordIDs={this.state.recordIDs} {...this.props } ></AMTSalesActionsBox>*/}
                        <AMTSalesProductsSearchBox ref={(searchBox) => {
                            if (searchBox && !this[this.state.currentScreen+'SearchBox']) {
                                this[this.state.currentScreen+'SearchBox'] = searchBox;
                                this.search({page: this.state.currentPage})
                            }
                        } }
                                           resetSearch={this.resetSearch.bind(this)}
                                           search={this.search.bind(this)}
                                           selectAllRecords={this.state.selectAllRecords}
                                           toggleAllRecordsSelection={this.toggleAllRecordsSelection.bind(this)}     {...this.props} ></AMTSalesProductsSearchBox>
                        {( this.state.productsList.total == 0) ?
                            <div
                                className="messageBox">{config.clientMessages.noRecordsFoundForCriteria.replace("#1#", 'products')}</div> :
                            <div>
                                {this.state.productsList.total == 'initial' ? null:
                            <div className="top20">
                                <AMTSalesProductsListTable
                                    search={this.search.bind(this)}
                                    // onRowSelect ={onRowSelect.bind(this)}
                                    // customMultiSelect ={customMultiSelect.bind(this)}
                                    // showRemoveDialog={(row)=>{
                                    //     this.setState({removeRecordModalVisible: true, currentRecord: row});
                                    // }}
                                    // onAllRowSelect ={onAllRowSelect.bind(this)}
                                    updateProductRecord={this.updateProductRecord.bind(this)}
                                    openModalDialog={this.openModalDialog.bind(this)}
                                    currentPage={this.state.currentPage}
                                    total={this.state.productsList.total == 'initial' ? 0 : this.state.productsList.total}
                                    tableData={this.state.productsList.data}
                                    onSortChange={this.onSortChange.bind(this)} {...this.props}   ></AMTSalesProductsListTable>
                                <PaginationBox
                                    ref={'pagination'}
                                    currentPage={this.state.currentPage}
                                    perPage={this[this.state.currentScreen+'SearchBox'] ?this[this.state.currentScreen+'SearchBox'].state.filterOptions.perPage : undefined}
                                    total={this.state.productsList.total == 'initial' ? 0 : this.state.productsList.total}
                                    search={this.search.bind(this)}>
                                </PaginationBox>
                            </div>}
                            </div>}
                    </div> : <div>
                        <AMTSalesNotificationsSearchBox ref={(searchBox) => {
                            if (searchBox && !this[this.state.currentScreen+'SearchBox']) {
                                this[this.state.currentScreen+'SearchBox'] = searchBox;
                                this.search({page: this.state.currentPage })
                            }
                        } }
                                           resetSearch={this.resetSearch.bind(this)}
                                           search={this.search.bind(this)}
                                           selectAllRecords={this.state.selectAllRecords}
                                           toggleAllRecordsSelection={this.toggleAllRecordsSelection.bind(this)}     {...this.props} ></AMTSalesNotificationsSearchBox>
                        {( this.state.notificationsList.total == 0) ?
                            <div
                                className="messageBox">{config.clientMessages.noRecordsFoundForCriteria.replace("#1#", 'notifications')}</div> :
                            <div>
                            {this.state.notificationsList.total == 'initial' ? null:
                            <div className="top20">
                                <AMTSalesNotificationsListTable
                                    search={this.search.bind(this)}
                                    deleteSubscription={this.deleteSubscription.bind(this)}
                                    openModalDialog={this.openModalDialog.bind(this)}
                                    currentPage={this.state.currentPage}
                                    total={this.state.notificationsList.total == 'initial' ? 0 : this.state.notificationsList.total}
                                    tableData={this.state.notificationsList.data}
                                    onSortChange={this.onSortChange.bind(this)} {...this.props}   ></AMTSalesNotificationsListTable>
                                <PaginationBox
                                    ref={'pagination'}
                                    currentPage={this.state.currentPage}

                                    perPage={this[this.state.currentScreen+'SearchBox'] ? this[this.state.currentScreen+'SearchBox'].state.filterOptions.perPage : undefined}
                                    total={this.state.notificationsList.total == 'initial' ? 0 : this.state.notificationsList.total}
                                    search={this.search.bind(this)}>
                                </PaginationBox>
                            </div>}</div>}

                    </div>
                }

                <Modal show={_.get(this.state,'currentRecord._id') ? true:false  }
                       onHide={(e) => this.setState({currentRecord: {}})}>
                    <Modal.Header>
                        <Modal.Title><div className="text-center purple">{_.get(this.state,'currentRecord.currentAction') == 'CopyDescription' ? 'Description' :
                            (_.get(this.state,'currentRecord.currentAction') == 'SignUpForNotification') ? 'Notifications' :
                                (_.get(this.state,'currentRecord.currentAction') == 'AddUserNotes') ? 'Notes':''}</div>
                            </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {this.displayModalContent()}
                    </Modal.Body>
                    <Modal.Footer>
                        <Row className="left0">
                            <Col md={12} sm={12} xs={12} className="pleft0">
                                <Button className="pull-left btn   btn-default" type="button"
                                        onClick={(e) => this.setState({
                                            currentRecord:{}
                                        })}>
                                    Cancel
                                </Button>
                                {_.get(this.state, 'currentRecord.currentAction') == 'DisplayProductImages' &&
                                <Link className="cursor-pointer" onClick={() => {

                                this.forceDownload(_.snakeCase(_.get(this.state.currentRecord, 'ProductName','Image')),_.get(this.state.currentRecord, ['OriginalImages',_.get(this.imageSlider, 'state.selectedItem'), 'URL']))

                                }}><FaDownload style={{fontSize: 28}}></FaDownload></Link>

                                }
                                {_.get(this.state, 'currentRecord.currentAction') == 'DisplayProductImages1' &&
                                <a href={formatImageForBucket(_.get(this.state.currentRecord, ['OriginalImages',_.get(this.imageSlider, 'state.selectedItem'), 'URL']))}
                                   download="expenses.jpeg">  <img download style={{ maxWidth:'400px',  maxHeight:'400px'}} title={''}  src={formatImageForBucket(_.get(this.state.currentRecord, ['OriginalImages',_.get(this.imageSlider, 'state.selectedItem'), 'URL']))} /></a>

                                }


                                {_.get(this.state, 'currentRecord.currentAction') !== 'DisplayProductImages' &&
                                <Button className="pull-right"
                                        disabled={function () {
                                            if (self.state.pending){
                                                return true;
                                            }else   if (_.get(self.state, 'currentRecord.currentAction') == 'SignUpForNotification' && (
                                                _.size(_.difference(_.get(self.state, 'currentRecord.notificationTypes',[]),_.map(_.get(self.state.currentRecord,'ProductSubscriptions',[]),'Type')))==0 &&
                                                _.size(_.difference(_.map(_.get(self.state.currentRecord,'ProductSubscriptions',[]),'Type'),_.get(self.state, 'currentRecord.notificationTypes',[])))==0)) {
                                                return true;
                                            } else if (_.get(self.state, 'currentRecord.currentAction') == 'AddUserNotes' && !_.get(self.state, 'currentRecord.UserNotes')) {
                                                return true;
                                            }
                                        }()
                                        }
                                        onClick={(e) => {
                                            if (_.includes(['CopyDescription', 'DisplayUserNotes'], _.get(this.state, 'currentRecord.currentAction'))) {
                                                if (_.get(this.state, 'currentRecord.currentAction') == 'CopyDescription') {
                                                    var text = _.get(this.state.currentRecord, 'Description', '')
                                                } else if (_.get(this.state, 'currentRecord.currentAction') == 'DisplayUserNotes') {
                                                    var text = _.get(this.state.currentRecord, 'CustomData.UserNotes', '')
                                                }
                                                navigator.clipboard.writeText(text)
                                                this.props.displayMessage({
                                                    'messageCode': 'Text copied to the clipboard',
                                                });
                                                this.setState({
                                                    currentRecord: {}
                                                })
                                            } else if (_.get(this.state, 'currentRecord.currentAction') == 'SignUpForNotification') {
                                                self.setState({
                                                     pending:true
                                                })
                                               var functionsToCall = []
                                                _.forEach(_.difference(_.get(self.state, 'currentRecord.notificationTypes',[]),_.map(_.get(self.state.currentRecord,'ProductSubscriptions',[]),'Type')), function (notificationType) {
                                                    functionsToCall.push(function (done) {
                                                        var formData = {
                                                            Type: notificationType,
                                                            Email: self.props.userReducer.user.email,
                                                            ShopifyProductID: _.get(self.state, 'currentRecord.ShopifyProductID'),
                                                            SubscriptionCustomData:{
                                                                SignedUpFrom:'dashboard'
                                                            }
                                                        }

                                                        self.props.makeRequest(formData, {
                                                            "endpoint": "/subscriptions",
                                                            type: "post",

                                                        }).then(res => {
                                                            self.props.displayMessage({
                                                                'messageCode': (notificationType == 'SoldOut' ? 'Sold out' :'Price drop') + ' subscription created',
                                                            });
                                                                done(null)
                                                        }).catch(err => {
                                                            done(null)
                                                        });
                                                    });
                                                });
                                                _.forEach(_.difference(_.map(_.get(self.state.currentRecord,'ProductSubscriptions',[]),'Type'),_.get(self.state, 'currentRecord.notificationTypes',[])), function (notificationType) {
                                                  var subscriptionToDelete = _.find(_.get(self.state.currentRecord,'ProductSubscriptions',[]), {Type:notificationType})
                                                    functionsToCall.push(function (done) {
                                                        self.props.makeRequest({
                                                        }, {
                                                            type: 'delete',
                                                            "endpoint": "/subscriptions" + '/' + encodeURIComponent(subscriptionToDelete._id),
                                                        }).then(res => {
                                                            self.props.displayMessage({
                                                                'messageCode': (notificationType == 'SoldOut' ? 'Sold out' :'Price drop') + ' subscription deleted',
                                                            });
                                                            done(null)
                                                        }).catch(err => {
                                                            done(null)
                                                        });
                                                    });
                                                });
                                                async.parallel(functionsToCall,
                                                    function (err, uploadResponses) {
                                                        if (err) {

                                                        }
                                                        self.setState({
                                                            currentRecord: {},pending:false
                                                        })
                                                        self.search({page: self.state.currentPage })
                                                    });


                                            } else if (_.get(this.state, 'currentRecord.currentAction') == 'AddUserNotes') {
                                                var formData = {
                                                    CustomData: {
                                                        UserNotes: _.get(this.state.currentRecord, 'UserNotes', '')
                                                    }
                                                }
                                                this.props.makeRequest(formData, {
                                                    "endpoint": "/products/" + encodeURIComponent(_.get(this.state, 'currentRecord._id')),
                                                    type: "patch",

                                                }).then(res => {
                                                    self.props.displayMessage({
                                                        'messageCode': 'Note added',
                                                    });
                                                    self.setState({
                                                        currentRecord: {},
                                                    })
                                                    self.search({page: self.state.currentPage })
                                                }).catch(err => {
                                                });
                                            }else if (_.get(this.state, 'currentRecord.currentAction') == 'UpdateCrossPosted') {
                                                var formData = {
                                                    CustomData: {
                                                        UserNotes: _.get(this.state.currentRecord, 'UserNotes', '')
                                                    }
                                                }
                                                this.props.makeRequest(formData, {
                                                    "endpoint": "/products/" + encodeURIComponent(_.get(this.state, 'currentRecord._id')),
                                                    type: "patch",

                                                }).then(res => {
                                                    self.props.displayMessage({
                                                        'messageCode': 'Note added',
                                                    });
                                                    self.setState({
                                                        currentRecord: {},
                                                    })
                                                    self.search({page: self.state.currentPage })
                                                }).catch(err => {
                                                });
                                            }


                                        }}
                                        bsStyle="primary">{  _.includes(['CopyDescription', 'DisplayUserNotes'], _.get(this.state, 'currentRecord.currentAction')) ? 'Copy' :
                                    (_.get(this.state, 'currentRecord.currentAction') == 'SignUpForNotification') ? 'Save' :
                                        (_.get(this.state, 'currentRecord.currentAction') == 'AddUserNotes') ? 'Save' : ''}</Button>
                                }
                            </Col>
                        </Row>
                    </Modal.Footer>
                </Modal>

            </div>
        );
    }
}

function mapStateToProps(state) {
    return {'adminContractors': state.adminContractors,
        'userReducer': state.userReducer
    };

}
function mapDispatchToProps(dispatch) {
    return bindActionCreators({makeRequest,displayMessage, dispatchAction}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(AMTSalesPage);
